import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Feedback from '../components/ScoreFeedback/Feedback'

const ScoreFeedback = () => {
  return (
    <>
        <Navbar />
        <Feedback />
    </>
  )
}

export default ScoreFeedback